

export const getAdminCardCounts = async () => {

    try {
        

		let response = await fetch(`api/Dashboard/CardCounts`);

        if (!response.ok)
            throw new Error(response.statusText);

        return response.json();

    } catch (error) {
        console.error(error);
        throw error;
    }
};